/*
 * @Descripttion:
 * @Author: shenah
 * @Date: 2023-04-28 10:15:42
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-11-22 15:58:25
 */
function createExcelField(rows, strArr, index) {
  rows[index] = {};
  let cells = {};
  strArr.forEach((str, strIndex) => {
    if (index === 0 && strIndex === 0) {
      cells[0] = { text: "字段名", editable: false };
    } else if (index === 1 && strIndex === 0) {
      cells[0] = { text: "字段名描述", editable: false };
    }
    cells[strIndex + 1] = { text: str };
  });
  rows[index].cells = cells;
}
function createExcelData(rows, data, keys) {
  data.forEach((row, rowIndex) => {
    let cells = {
      0: { text: "" },
      1: { text: "" },
    };
    rows[rowIndex + 2] = {};
    keys.forEach((key, keyIndex) => {
      cells[keyIndex + 1] = { text: row[key] };
    });
    rows[rowIndex + 2].cells = cells;
  });
}
/**
 * @description: 对象转字符串
 * @param {object} o 传入的对象
 * @param {boolean} level 是否是第一层级
 */
let objectTostring = function (o, level) {
  if (o === null) {
    return "null,\n";
  } else if (typeof o === "string") {
    return JSON.stringify(o) + ",\n";
  } else if (typeof o === "function") {
    return o.toString() + ",";
  } else if (Array.isArray(o)) {
    let val = `[
      `;
    o.forEach((it) => {
      val += `${this.objectTostring(it)}`;
    });
    val += `]`;
    return `${val},\n`;
  } else if (typeof o === "object") {
    let val = `{
      `;
    Object.keys(o).forEach((key) => {
      val += `${key}:`;
      val += this.objectTostring(o[key]);
    });
    val += `}`;
    if (level) {
      return `${val}\n`;
    }
    return `${val},\n`;
  } else {
    return `${o},\n`;
  }
};
/**
 * @description: 处理小数不用对象的方式传
 * @param {string|number} data 传入的数据
 * @param {number} digit 保留几位小数
 * @param {boolean} isKeep 是否保留0
 * @param {number} type 0代表四舍五入1代表向上取证2代表向下舍入
 * @return {string|number} 保留0就是字符串,不保留就是number
 */
let handleDecimal = (data, digit = -1, isKeep = false, type = 0) => {
  let nowData = Number(data);
  if (isNaN(nowData) || digit < 0 || digit > 100) {
    return data;
  }
  let methodObj = {
    0: _.round,
    1: _.ceil,
    2: _.floor,
  };
  let method = methodObj[type];
  if (!method) {
    return data;
  }
  nowData = method(nowData, digit);
  if (isKeep) {
    return nowData?.toFixed(digit) || data;
  }
  if (isNaN(nowData)) {
    return data;
  }
  return nowData;
};

/**
 * @name: 设置颜色透明度
 * @param {String} colorStr 颜色的字符串
 * @param {number} opacity 透明度
 * @return {*}
 */
let setColorOpacity = (colorStr, opacity) => {
  let colorObj = tinycolor(colorStr);
  colorObj.setAlpha(opacity);
  return tinycolor(colorObj).toString();
};
/**
 * @name: 获取颜色的透明度
 * @param {String} colorStr 颜色的字符串
 * @param {number} opacity 透明度
 * @return {*}
 */
let getColorOpacity = (colorStr) => {
  let rgba = tinycolor(colorStr).toRgb();
  return rgba.a;
};
/**
 * @name: 实现渐变
 * @param {*} startColor 开始的颜色
 * @param {*} endColor 结束的颜色
 * @param {*} index
 * @return {*}
 */
let gradientColor = (startColor, endColor, index) => {
  var start = tinycolor(startColor).toRgb();
  var end = tinycolor(endColor).toRgb();
  var result = {
    r: Math.round((end.r - start.r) * index + start.r),
    g: Math.round((end.g - start.g) * index + start.g),
    b: Math.round((end.b - start.b) * index + start.b),
  };
  return tinycolor(result).toString();
};

let getRandomColor = () => {
  var r = Math.floor(Math.random() * 256); //生成红色0-255
  var g = Math.floor(Math.random() * 256); //生成绿色0-255
  var b = Math.floor(Math.random() * 256); //生成蓝色0-255
  return `rgb(${r},${g},${b})`;
};

/**
 * 判断是否为老版本的excel解析的数据
 * @param {Object} res excel数据对象
 * @param {String|undefined} chartType echarts的类型(目前没有使用)
 * @return {Boolean}
 */
let judgeIsOldChatExcel = (res) => {
  if (!res.length) return;
  const rows = res[0].rows;
  const filterRow = rows[0].cells;
  let firstOneOne = filterRow[0];
  let flag = true;
  let text = firstOneOne.text?.trim() || "";
  let editable = firstOneOne?.editable;
  if (text === "字段名" && editable === false) {
    flag = false;
  }
  return flag;
};

/**
 * @name: 数据分析表格通用处理data为表格数据
 * @param {*} data 静态数据
 * @param {*} desObj 数据里面的字段的描述
 * @return {*}
 */
let dataAnalysisTransFormExcel = (
  data,
  desObj = {
    name: "名称",
    value: "值",
    des: "描述",
  }
) => {
  // 生成字段名与描述
  let desKeys = Object.keys(desObj);
  let dataKeys = Object.keys(data[0] || {});
  let keys = dataKeys.length ? dataKeys : desKeys;
  let desArr = keys.map((key) => desObj[key] || "未知字段");
  let rows = {};
  createExcelField(rows, keys, 0);
  createExcelField(rows, desArr, 1);
  createExcelData(rows, data, keys);
  return rows;
};
/**
 * @name: 解析表格对象=>并转化为数组对象
 * @param {Array} res 表格对象
 * @return {*}
 */
let dataExcelCommonExcelToArrayObj = (res, callback) => {
  if (!res.length) return;
  const rows = res[0].rows;
  //字段映射表
  let fields = new Map()
  // 解析出字段
  Object.keys(rows[0].cells).forEach((key, index) => {
    if (index !== 0) {
      let field = rows[0].cells[key]?.text || 0;
      let aliasName = rows[1].cells[key]?.text || `未知字段${index + 1}`;
      fields.set(index, {
        name: aliasName,
        value: field
      })
    }
  });

  let data = [];
  // 解析出数据
  Object.keys(rows).forEach((key) => {
    if (key !== "0" && key !== "1") {
      //数据项
      let row = rows[key].cells;
      //数据对象
      let item = {};
      let isEmpty = true
      if (row && typeof row === "object") {
        for (let key of fields.keys()) {
          let field = fields.get(key).value
          if (row[key] && row[key].text) {
            item[field] = row[key].text
            isEmpty = false
          } else {
            item[field] = undefined
          }
        }
        if (!isEmpty) {
          data.push(item);
        }
      }
    }
  });
  if (callback) {
    callback([...fields.values()])
  }
  return data;
};
/**
 * @name: 数字转化为千分位
 * @param {*} str 任意类型
 * @return {*} string
 */
let toThSeparator = (str) => {
  // 将数字转换为字符串
  if (!dsf.isNumber(str)) {
    return str;
  }
  let strNumber = str?.toString() || "";
  // 使用正则表达式添加千分位分隔符
  strNumber = strNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return strNumber;
};

/**
 * @description: 获取静态资源路径
 * @param {*} startColor 开始的颜色
 * @param {*} endColor 结束的颜色
 * @param {*} index
 * @return {*}
 */
let getWebPath = function (url) {
  let page = this.$page || this;
  if (this.isDesign) {
    return dsf.url.getWebPath(url);
    //使用微服务标识
  } else if (page.uploadSign) {
    // $servicePrefix
    return dsf.url.getWebPath(url, this.$servicePrefix || $$webRoot.default);
  }
  return dsf.url.getWebPath(url);
};
/**
 * @description: 数字单位换算
 * @param {*} number 数据
 * @param {*} unitVal 分割量级(如10,100)
 * @param {*} decimalNum 小数位
 * @param {*} divider 分割符
 * @return {*} number
 */
let transformUnit = function (
  number,
  unitVal,
  isUnit = true,
  decimalNum,
  divider
) {
  let unitObj = dsf.dataview.units
  let unit = unitObj[unitVal];
  if (!number || isNaN(Number(number))) {
    return number;
  }
  if (unit) {
    number = number / unitVal;
  }
  const strSplit = number.toString().split(".");
  const integer = strSplit[0];
  let decimal = strSplit[1] || "";
  if (decimalNum && decimal) {
    decimal = decimal.substr(0, decimalNum);
  }
  if (divider) {
    return (
      integer.replace(/\B(?=(\d{3})+(?!\d))/g, divider) +
      (decimal ? "." + decimal : "") +
      (isUnit ? unit : "")
    );
  }
  return integer + (decimal ? "." + decimal : "") + (isUnit ? unit : "");
};
let compatiblePathToExtendImg = function (obj, active = "custom") {
  if (!obj || typeof obj === "string") {
    return {
      active,
      custom: {
        image: obj ? obj : "",
        static: false,
        size: "cover",
        repeat: "no-repeat",
        position: "center",
      },
    };
  }
  return obj;
};
let compatiblePathToExtendShowImg = function (obj) {
  let nowObj =  dsf.dataview.utils.compatiblePathToExtendImg(obj);
  let url = nowObj?.custom.image || "";
  return  dsf.dataview.utils.getWebPath(url);
};
// 加载js的资源
let loadJsSource = function (url) {
  let urls = url;
  if (typeof urls === "string") {
    urls = [urls];
  }
  return new Promise((resolve, reject) => {
    const loadScript = (curl, index) => {
      try {
        let script = document.createElement("script");
        script.charset = "utf-8";
        script.src = curl;
        document.head.appendChild(script);
        script.onload = function () {
          if (index === urls.length - 1) {
            resolve();
          }
        };
      } catch (error) {
        reject(error);
      }
    };
    urls.forEach((curl, index) => {
      loadScript(curl, index);
    });
  });
};
let loadCssSource = function (url) {
  return new Promise((resolve, reject) => {
    try {
      let linkElement = document.createElement("link");
      linkElement.rel = "stylesheet";
      linkElement.href = url;
      document.head.appendChild(linkElement);
      linkElement.onload = function () {
        resolve();
      };
    } catch (error) {
      reject(error);
    }
  });
};

/**
 * 解析tooltip中html中的属性的值并转化为echarts相应的属性
 * @param {*} html 需要解析的html
 * @param {*} param formatter对应的单个param
 * @return {*}
 */
const analyzeToolTipHTMLAttr = function (html, param, type = "chart", hiddenField = []) {
  // 特殊字段的映射
  let specialField = {
    seriesName: "系列名",
    name: "名称",
    value: "值",
    marker: "图例",
  };
  // 创建一个临时容器元素
  const container = document.createElement("div");
  container.innerHTML = html;
  // 获取含有 real-value 属性的元素
  const elements = container.querySelectorAll("[real-value]");
  elements.forEach((element) => {
    const realValue = element.getAttribute("real-value");
    let replacement = "";
    if (type === "chart") {
      let data = param.data;
      if (data && typeof data === "object") {
        if (["seriesName", "name", "value", "marker"].indexOf(realValue) > -1) {
          replacement = data[realValue] || param[realValue] || "-- ";
        } else {
          replacement = data[realValue] || "";
        }
      } else {
        if (["seriesName", "name", "value", "marker"].indexOf(realValue) > -1) {
          replacement = param[realValue] || "-- ";
        }
      }
    } else if (["gis"].indexOf(type) > -1) {
      let data = param.properties;
      replacement = data[realValue];
      if (replacement === undefined) {
        replacement = "-- ";
      }
    } else if (["textBox"].indexOf(type) > -1) {
      let data = param;
      replacement = data[realValue];
      if (replacement === undefined) {
        replacement = "-- ";
      }
    }
    if (hiddenField?.indexOf(realValue) > -1) {
      replacement = "";
    }
    let oldInnerHTML = element.innerHTML;
    let nowHTML =
      oldInnerHTML?.replace(/(<(.[^>]*)>)|(&nbsp;)/g, "").trim() || "";
    let newRealValue = realValue;
    if (!nowHTML.includes(realValue)) {
      if (type === 'textBox') {
        newRealValue = nowHTML;
      } else {
        newRealValue = specialField[realValue];
      }
    }
    element.innerHTML = oldInnerHTML.replaceAll(newRealValue, replacement);
  });
  // 返回替换后的 HTML 字符串
  return container.innerHTML;
};

/**
 * 判断是否有内容
 * @param {*} html
 * @return {*}
 */
const hasTextContent = function (html) {
  let reg = /(<(.[^>]*)>)|(&nbsp;)/g;
  html = html?.replace(reg, "").trim() || "";
  if (html) {
    return true;
  }
  return false;
};
//拍平树
const flatTree = function (tree) {
  let result = [];
  if (!Array.isArray(tree)) return [];
  while (tree.length) {
    let current = tree.shift();
    let { children, ...properties } = current;
    result.push(properties);
    if (children && children.length) {
      tree.push(...children);
    }
  }
  return result;
};
//构建树
const establishTree = function (arr, id, realId, realPid) {
  id = id + "";
  let map = new Map();
  arr.forEach((it) => {
    let _id = it[realId] + "";
    let current = map.get(_id);
    if (!current) {
      it.children = [];
      map.set(_id, it);
    } else {
      let children = current.children;
      it.children = children;
    }
    let pid = it[realPid] + "";
    let parent = map.get(pid);
    if (parent) {
      parent.children.push(it);
    } else {
      map.set(pid, {
        children: [it],
      });
    }
  });
  if (map.get(id)) {
    return map.get(id).children;
  } else {
    return [];
  }
};
const transformPx = function (size) {
  if (dsf.isNumber(size) || /^\d+$/g.test(size)) {
    size += "px";
  }
  size = dsf.pxToRem(size);
  return size;
}
const transformArrayPx = function (arr) {
  if (!Array.isArray(arr)) {
    return arr;
  }
  let list = [];
  list = arr.map((str) => transformPx(str)).join(" ");
  return list;
}
//风格中图片id的转化
const getUplaodImageById = function (src) {
  if (/\/upload\/file\/.+/.test(src)) {
    return src;
  } else {
    if (src) {
      return `/upload/file/png/${src}`;
    }
    return src;
  }
}
const colorFormat = function (opt) {
  if (!opt) {
    return {};
  }
  let { active, color, pattern, custom } = opt;
  switch (active) {
    case "color":
      let { isTheme, theme, value, type, image } = color;

      if (type == "color") {
        return {
          "background-color": isTheme
            ? dsf.themeConfig.currentTheme[theme]
            : value,
        };
      } else {
        return { background: image };
      }
    case "pattern":
      if (pattern) {
        let imgUrl = getUplaodImageById(pattern.image) || pattern.image; // 当弹框的时候$designer就不存在
        imgUrl = dsf.dataview.utils.getWebPath(imgUrl);
        return {
          "background-image": imgUrl ? `url('${imgUrl}')` : "none",
          "background-size": pattern.size,
          "background-repeat": pattern.repeat,
          "background-position": pattern.position,
        };
      }
      break;
    case "custom":
      if (custom) {
        return {
          "background-image": `url('${dsf.dataview.utils.getWebPath(custom.image)}')`,
          "background-size": custom.size,
          "background-repeat": custom.repeat,
          "background-position": custom.position,
        };
      }
  }
  return {};
}
/*
  该方法与 $colorFormat 存在差异
  $colorFormat 方法中，单色、背景图、自定义背景图、线性渐变和径向渐变只能存在一种
  $colorFormatCoexist 方法中，单色与背景图/自定义背景图可同时存在， 单色、背景图/自定义背景图与渐变色仍互斥
*/
const colorFormatCoexist = function (config) {
  if (!config) return {}
  let { active, pattern, custom } = config,
    style = {};
  // 添加背景色
  if (active === "color") {
    style = colorFormat({
      ...config,
      active: "color",
    });
    // 添加背景/自定义背景
    if (pattern?.image || custom?.image) {
      style = {
        ...style,
        ...colorFormat({
          ...config,
          active: pattern?.image ? "pattern" : "custom",
        }),
      };
    }
  } else {
    style = {
      ...colorFormat({
        ...config,
        active,
      }),
    };
  }
  return style;
}
let dataviewUtils = {
  colorFormat,
  colorFormatCoexist,
  transformPx,
  transformArrayPx,
  flatTree,
  establishTree,
  objectTostring,
  handleDecimal,
  gradientColor,
  getRandomColor,
  dataAnalysisTransFormExcel,
  dataExcelCommonExcelToArrayObj,
  judgeIsOldChatExcel,
  toThSeparator,
  getWebPath,
  transformUnit,
  compatiblePathToExtendImg,
  compatiblePathToExtendShowImg,
  loadJsSource,
  loadCssSource,
  analyzeToolTipHTMLAttr,
  hasTextContent,
  setColorOpacity,
  getColorOpacity
};
export default dataviewUtils;
